import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class MotivoGeralService extends CRUDService{
    constructor() {
        super("motivogeral");
    }

    listMotivoAtraso() {
        return http.get("/"+this.serviceName+"/escopo/ATRCO")
    }

    listMotivoSubstituicaoCPF() {
        return http.get("/"+this.serviceName+"/escopo/SUBST")
    }

    listMotivoTerminoAntecipado() {
        return http.get("/"+this.serviceName+"/escopo/TERMI")
    }

    listMotivoSubstituicaoMOTAlocada() {
        return http.get("/"+this.serviceName+"/escopo/SUBRA")
    }

    listMotivoDesistenciaAlocacaoETT() {
        return http.get("/"+this.serviceName+"/escopo/DESIS")
    }
}